<template>
<div class="email-template-wrapper">
    <b-row cols="1" cols-lg="2">
        <b-col>
             <p-input name="from"
                                 v-model="emailDetail.fromName"
                                 label="From Name"
                                 rules="max:100" />
        </b-col>
        <b-col>
             <p-input name="to"
                                 v-model="emailDetail.replyEmail"
                                 label="Reply to"
                                 rules="email|max:254" />
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <p-input name="subject"
                                 v-model="emailDetail.emailSubject"
                                 label="Subject"
                                 rules="max:1000" />
        </b-col>
    </b-row>
    <b-row class="mb-3">
        <b-col>
            <custom-quill-editor v-model:content='emailDetail.emailContent' content-type="html" />
        </b-col>
    </b-row>
</div>
</template>
<script>
import 'quill/dist/quill.snow.css';
export default {
    name: 'EmailTemplate',
    components: {
    },
    props: {
        emailDetail:{
                fromName:"",
                replyEmail:"",
                emailSubject:"",
                emailContent:""
            }


    },
    data() {
        return {
            
        }
    }
}
</script>
<style scoped lang="scss">
   .email-template-wrapper {
        min-width: 0;
   }
   :deep(.ql-image),
   :deep(.ql-video) {
        display: none !important;
   }
   :deep(.quill-editor),
   :deep(.ql-toolbar),
   :deep(.ql-container) {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
   }
   :deep(.ql-editor) {
        min-width: 0;
        min-height: 80px;
        height: auto;
        word-break: break-word;
        overflow-wrap: break-word;
   }
   :deep(.ql-container) {
        min-height: 80px;
        height: auto !important;
   }
</style>